import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BookingTechnicalInformationsComponent } from './booking-technical-informations.component';
import { CardModule } from 'libraries/ui_card/card.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { InterfaceFlagModule } from "libraries/component/interface-flag/interface-flag.module";
import { ExternalBookingModule } from "libraries/component/external-booking/external-booking.module";

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        DatePipeModule,
        HostAliasPipeModule,
        FontAwesomeModule,
        InterfaceFlagModule,
        ExternalBookingModule,
    ],
    declarations: [
        BookingTechnicalInformationsComponent,
    ],
    exports: [
        BookingTechnicalInformationsComponent,
    ],
})
export class BookingTechnicalInformationsModule {
}
